import { Button, Intent } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import * as React from "react";

import { useTl } from "../../hooks";
import { ETLCodes } from "../../locales";
import { ICustomButtonProps } from "./ICustomButtonProps";
import { useAuth } from "../../contexts";

interface IDeleteButtonProps extends Omit<ICustomButtonProps, "onClick"> {
  onDelete?: () => void;
  secured?: boolean;
}

export const DeleteButton: React.FunctionComponent<IDeleteButtonProps> = ({
  minimal = true,
  onDelete,
  loading,
  disabled,
  intent = Intent.DANGER,
  secured = true,
  ...otherProps
}) => {
  const { t } = useTl();
  const { getCurrentPermission } = useAuth();
  const hasRights = React.useMemo(() => getCurrentPermission()?.permission === "RWD", [getCurrentPermission]);
  return (
    (hasRights || !secured) && (
      <Button
        icon={IconNames.TRASH}
        minimal={minimal}
        onClick={onDelete}
        text={minimal ? null : otherProps.text ?? t(ETLCodes.General_Delete)}
        intent={intent}
        loading={loading}
        disabled={disabled || (secured && !hasRights)}
      />
    )
  );
};
